import React from 'react';
import { Link } from 'react-router-dom';

function Navigation() {
  return (
    <nav className="navigation">
      <Link to="/" className="logo">Boligbar</Link>
      <ul>
        <li><Link to="/">Barometer</Link></li>
        <li><Link to="/explanations">Forklaring</Link></li>
      </ul>
    </nav>
  );
}

export default Navigation; 